<empusa-core-spinner *ngIf="spinnerSrv.loading" [overlay]="true"></empusa-core-spinner>
<div class="modal-content">
  <div class="modal-header">
    <h3 class="modal-title font">Previsualización Aportación DI/FS</h3>
    <button type="button" (click)="closeDialog()" class="close" data-dismiss="modal" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="row form" style="margin-bottom:1em;">
      <span class="nombre-archivo info-documento">{{this.aportacion?.documento!.nombre}}</span>
    </div>

    <iframe *ngIf="fileUrl && fileType === 'application/pdf'" [src]="fileUrl" width="100%" height="600"></iframe>
    <iframe *ngIf="fileUrl && fileType === 'text/plain'" [src]="fileUrl" width="100%" height="600"></iframe>
    <img *ngIf="fileUrl && fileType?.startsWith('image/')" [src]="fileUrl" alt="Imagen" />

    <span class="nombre-archivo" *ngIf="fileUrl && !tiposFicheroPermitidos.includes(fileType!) && !fileType?.startsWith('image/')">
      No se puede previsualizar este tipo de archivo
    </span>
  </div>

  <div class="fixed-footer">
    <div class="modal-footer actions">
      <div class="note"></div>
      <div class="button-group">
        <button type="button" (click)="closeDialog()" class="btn btn-outline-primary" data-dismiss="modal" aria-label="Close">Volver</button>
      </div>
    </div>
  </div>
</div>
